import {
  getPaymentHistories,
  getPaymentHistoryDetails,
  getReceiptUserDetails,
} from "../../endpoints/stripe.service";
import {
  FETCH_PAYMENT_HISTORIES_FAILURE,
  FETCH_PAYMENT_HISTORIES_REQUEST,
  FETCH_PAYMENT_HISTORIES_SUCCESS,
  FETCH_PAYMENT_HISTORY_DETAILS_FAILURE,
  FETCH_PAYMENT_HISTORY_DETAILS_REQUEST,
  FETCH_PAYMENT_HISTORY_DETAILS_SUCCESS,
  FETCH_RECEIPT_USER_DETAILS_FAILURE,
  FETCH_RECEIPT_USER_DETAILS_REQUEST,
  FETCH_RECEIPT_USER_DETAILS_SUCCESS,
  SET_CLIENT_SECRET,
  SET_CONNECTED_ACCOUNT_DATA,
  SET_PAYMENT_METHODS,
  SET_REFERRAL_DETAILS,
} from "./action.types";

export const setClientSecret = (payload) => ({
  type: SET_CLIENT_SECRET,
  payload,
});

export const setConnectedAccountDetails = (payload) => ({
  type: SET_CONNECTED_ACCOUNT_DATA,
  payload,
});

export const setReferralDetais = (payload) => ({
  type: SET_REFERRAL_DETAILS,
  payload,
});

export const setPaymentMethods = (payload) => ({
  type: SET_PAYMENT_METHODS,
  payload,
});

const CACHE_DURATION = 1 * 60 * 1000; // 1 minutes
// Thunk to fetch payment histories
export const fetchPaymentHistories = (
  page,
  paymentType,
  searchText,
  startDate,
  endDate
) => {
  return async (dispatch, getState) => {
    const state = getState();

    dispatch({ type: FETCH_PAYMENT_HISTORIES_REQUEST });
    try {
      const response = await getPaymentHistories(
        page,
        paymentType,
        searchText,
        startDate,
        endDate
      );
      if (response.success) {
        console.log("action fetch response", response.data);
        dispatch({
          type: FETCH_PAYMENT_HISTORIES_SUCCESS,
          payload: {
            paymentHistories: response?.data?.paymentHistories,
            hasMore: response?.data?.hasMore,
            page: response?.data?.page,
            wasSearchResult: !!searchText, // add flag to indicate if this was search result
          },
        });
        return response.data;
      }
    } catch (error) {
      dispatch({
        type: FETCH_PAYMENT_HISTORIES_FAILURE,
        payload: error.message,
      });
    }
  };
};

// thunk to fetch payment history details
export const fetchPaymentHistoryDetails = (id, type) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_PAYMENT_HISTORY_DETAILS_REQUEST });
    try {
      const response = await getPaymentHistoryDetails(id, type);
      if (response.success) {
        dispatch({
          type: FETCH_PAYMENT_HISTORY_DETAILS_SUCCESS,
          payload: {
            paymentHistoryDetails: response?.data,
          },
        });
        return response.data;
      }
    } catch (error) {
      dispatch({
        type: FETCH_PAYMENT_HISTORY_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };
};

// thunk to fetch payment receipt user (referral/candidate) and job details
export const fetchReceiptUserDetails = (userId, jobId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_RECEIPT_USER_DETAILS_REQUEST });
    try {
      const response = await getReceiptUserDetails(userId, jobId);
      console.log("fetch receipt user details response", response);
      if (response.success) {
        dispatch({
          type: FETCH_RECEIPT_USER_DETAILS_SUCCESS,
          payload: {
            receiptUserDetails: response?.data,
          },
        });
        return response.data;
      }
    } catch (error) {
      dispatch({
        type: FETCH_RECEIPT_USER_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };
};
